module.exports = __webpack_public_path__ + "h5/img/xxwq.0e6a665e.jpg";